// highchartsConfig.js

export function getPieChartOptions(
  Highcharts,
  { dataSearies, label = "", unavailableText = "", showLegend = false, showLabels = true }
) {
  return {
    credits: { enabled: false },
    colors: ["#777"],
    chart: {
      height: 400,
      borderRadius: 15,
      borderWidth: 1,
      borderColor: "#ccc",

      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "pie",

      events: {
        fullscreenOpen: function () {
          setTimeout(() => {
            this.series.forEach((s) => {
              s.update(
                {
                  dataLabels: {
                    style: { fontSize: "24px" },
                    connectorWidth: 3,
                    crop: false,
                    overflow: "none",
                  },
                },
                false
              );
            });
            this.userOptions.isFullscreen = true;
            this.legend.render();
            this.redraw(false);
          }, 50);
        },
        fullscreenClose: function () {
          setTimeout(() => {
            this.series.forEach((s) => {
              s.update(
                {
                  dataLabels: {
                    style: { fontSize: "12px" },
                    connectorWidth: 1,
                    crop: false,
                    overflow: "none",
                  },
                },
                false
              );
            });
            this.userOptions.isFullscreen = false;
            this.legend.render();
            this.redraw(false);
          }, 50);
        },
      },
    },
    responsive: {
      rules: [
        {
          condition: { maxWidth: 600 },
          chartOptions: {
            plotOptions: {
              pie: {
                dataLabels: {
                  distance: 15,
                },
              },
            },
          },
        },
        {
          condition: { maxWidth: 400 },
          chartOptions: {
            plotOptions: {
              pie: {
                dataLabels: {
                  distance: -10,
                },
              },
            },
          },
        },
      ],
    },
    subtitle: {
      align: "center",
      verticalAlign: "middle",
      text: `<h5 style='margin:0;font-size:18px;white-space:normal;width:80px;text-align:center;'>${unavailableText}</h5>`,
      y: 40,
      style: {
        position: "absolute",
        fontSize: "15px",
        fontWeight: "bold",
        color: "#777",
      },
    },
    plotOptions: {
      pie: {
        size: "72%",
        allowPointSelect: true,
        cursor: "pointer",
        useHTML: true,
        dataLabels: {
          enabled: showLabels,
          format: "{point.name}: {point.percentage:.2f}%",
        },
      },
    },
    legend: {
      enabled: showLegend,
      useHTML: true,
      layout: "horizontal",
      verticalAlign: "bottom",
      events: {
        itemClick: function (event) {
          event.preventDefault();
        },
      },
      labelFormatter: function () {
        const isFullscreen = this.series.chart.userOptions.isFullscreen;
        const fontSize = isFullscreen ? "24px" : "12px";
        const pct = this?.percentage;
        const text = `${this?.name}: ${Highcharts.numberFormat(pct, 2)}%`;
        return `<span style="font-size:${fontSize};">${text}</span>`;
      },
    },
    title: {
      text: label,
      align: "center",
    },
    tooltip: {
      enabled: true,
      headerFormat: "",
      pointFormat: "{point.name}: <b>{point.percentage:.2f}%</b>",
    },
    accessibility: {
      point: { valueSuffix: "%" },
    },
    series: [
      {
        innerSize: "70%",
        showInLegend: showLegend,
        enableMouseTracking: true,
        data: !dataSearies
          ? [
              {
                name: "",
                y: 100,
                color: "#777777",
              },
            ]
          : dataSearies,
      },
    ],
    exporting: {
      enabled: true,
      buttons: {
        contextButton: {
          menuItems: ["viewFullscreen", "printChart", "downloadPNG", "downloadJPEG"],
        },
      },
    },
  };
}
